import React, { useCallback, useEffect, useState } from 'react';
import { Link as RouterLink} from "react-router-dom";
import LotRow from 'components/LotRow';
import { fetchWithAuth } from 'utils/fetchWithAuth';
import { Alert, Link, Paper, Table, TableBody, TableRow, TableCell, Snackbar } from '@mui/material';

function SCIBlock({ sciId, selectedMonth }) {
  const [lots, setLots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };
  const API_URL = process.env.REACT_APP_API_URL;
  
  const fetchLots = useCallback(() => {
    setLoading(true);
    fetchWithAuth(`${API_URL}/api/scis/${sciId}/lots/?mois=${selectedMonth}`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setLots(data);
        } else {
          setLots([]);
          setError(data.detail || "Erreur inattendue lors du chargement des lots");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError("Erreur réseau !");
      });
  }, [API_URL, sciId, selectedMonth]);

  useEffect(() => {
    fetchLots();
  }, [fetchLots]);

  const refreshAllLots = () => {
    fetchLots();
  };

  if (loading) return <div>Chargement des lots...</div>;
  if (error) return <div style={{color: "red"}}>Erreur: {error}</div>;

  // Regroupement par bien
  const lotsGrouped = lots.reduce((acc, lot) => {
    const key = lot.bien.id;
    if (!acc[key]) {
      acc[key] = { bien: lot.bien, lots: [] };
    }
    acc[key].lots.push(lot);
    return acc;
  }, {});

  
  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Paper elevation={2} sx={{ border: "1px solid #d7e9ff", my: 2, p: 2 }}>
        <Table size="small">
          <TableBody>
            {Object.values(lotsGrouped).map(({ bien, lots }) => (
              <React.Fragment key={bien.id}>
                <TableRow>
                  <TableCell
                    colSpan={7}
                    sx={{
                      background: "#e3f0ff",
                      fontWeight: 700,
                      fontSize: "1em",
                      color: "#145fa6",
                      borderTop: "2px solid #bee3f8",
                      borderBottom: "2px solid #bee3f8",
                      pl: 2,
                      py: 1.4,
                      letterSpacing: "0.01em"
                    }}
                  >
                    <span role="img" aria-label="maison" style={{marginRight:8}}>🏠</span>
                    <Link
                      component={RouterLink}
                      to={`/biens/${bien.id}?mois=${selectedMonth}`}
                      sx={{ fontWeight: 700, color: "#145fa6", textDecoration: "none" }}
                    >
                      {bien.est_residence && bien.nom_residence
                        ? `${bien.nom_residence} - ${bien.adresse}`
                        : bien.adresse
                      }
                    </Link>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: "#f7fafb" }}>
                  <TableCell sx={{ fontWeight: 700 }}>Lot</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Locataire</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Date entrée</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Date sortie</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Loyer</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Statut paiement</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
                </TableRow>
                {lots.map(lot =>
                  <LotRow
                    key={lot.id}
                    lot={lot}
                    sciId={sciId}
                    selectedMonth={selectedMonth}
                    refreshLot={refreshAllLots}
                    showSnackbar={showSnackbar}
                  />
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
}
export default SCIBlock;